import axios from "axios";

export default {
    data(){ return {
        awaiting: null,
        cancels: {
            default: undefined
        },
    }},
    methods: {
        payloadGET(params, cancelID){
            params = params ? params : this.params;
            cancelID = cancelID ? cancelID : "default";
            if(this.cancels[cancelID])
                this.cancels[cancelID].cancel(this.messages.cancel);
            const CancelToken = axios.CancelToken;
            this.cancels[cancelID] = CancelToken.source();
            var payload = {params: Object.assign({}, params)};
            payload.cancelToken = this.cancels[cancelID].token;
            return payload;
        },
        payloadPOST(params){
            params = params ? params : this.params;
            var payload = params;
            // CANCEL
            //if(this.cancel !== undefined) this.cancel.cancel(this.messages.cancel);
            //const CancelToken = axios.CancelToken;
            //this.cancel = CancelToken.source();
            //payload.cancelToken = this.cancel.token;
            return payload;
        },


        // A SUPPRIMER
        payload(Oparams) {
            Oparams = Oparams ? Oparams : this.params;
            if(this.cancel !== undefined) this.cancel.cancel(this.messages.cancel);
            const CancelToken = axios.CancelToken;
            this.cancel = CancelToken.source();
            var payload = Object.assign({}, Oparams);
            payload.cancelToken = this.cancel.token;
            return payload;
        },
        postPayload(params){
            params = params ? params : this.params;
            if(this.cancel !== undefined) this.cancel.cancel(this.messages.cancel);
            const CancelToken = axios.CancelToken;
            this.cancel = CancelToken.source();
            var payload = Object.assign({}, params);
            payload.cancelToken = this.cancel.token;
            return payload;
        },
        getPayload(params){
            params = params ? params : this.params;
            var payload = {params: params};
            // CANCEL
            if(this.cancel !== undefined) this.cancel.cancel(this.messages.cancel);
            const CancelToken = axios.CancelToken;
            this.cancel = CancelToken.source();
            payload.cancelToken = this.cancel.token;
            return payload;
        },
    },
}